import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';

const DataTableBodyCellCheckbox = ({ checked, toggleChecked }) => {
  return (
    <TableCell variant={'head'} style={{ padding: '6px 10px' }}>
      <Checkbox checked={checked} onClick={(e) => e.stopPropagation()} onChange={toggleChecked} />
    </TableCell>
  );
};

DataTableBodyCellCheckbox.propTypes = {
  checked: PropTypes.bool,
  toggleChecked: PropTypes.func,
};

export default DataTableBodyCellCheckbox;
